import { withTranslation } from "react-i18next";
import { Link } from 'react-router-dom';
import { connect } from "react-redux";
import { Button, Divider } from "antd";
import { useEffect } from "react";

// Local
import Text from "components/Text";

// Redux
import { setGlobalBasket, setGlobalPaymentData } from "modules/ui/actions";
import Title from "components/Title";

/**
 * Success
 * @returns 
 */
const Success = (props) => {

  useEffect(() => {
    if (props.ui.globalBasket.length > 0 || props.ui.globalPaymentData) {
      props.setGlobalBasket([]);
      props.setGlobalPaymentData(null)
    }
  }, []); // eslint-disable-line

  return (
    <>
      <div style={{ width: '100%', margin: 'auto', marginTop: 20, backgroundColor: 'white', padding: 10 }}>
        <Title size={18}>Merci !</Title>
        <Divider style={{ margin: 10 }} />
        <Text size={14}>Votre commande a bien été enregistrée</Text>

        <Link to={`/orders/history`}>
          <Button style={{ marginTop: 10 }} type="primary">Voir mes commandes</Button>
        </Link>
      </div>
    </>
  )
}

const stateToProps = state => ({
  ui: state.ui
})

const dispatchToProps = {
  setGlobalBasket,
  setGlobalPaymentData
}

export default connect(stateToProps, dispatchToProps)(withTranslation()(Success));